import type { Intervention, InterventionRouteRequest } from '../../generated/api/types.gen.js';
import type { BadgeVariant } from '../../components/ui/Badge.js';

/** Policies that grant access to action requests (mirrors `MANAGE_ACTION_REQUEST_POLICIES` in the server route). */
export const MANAGE_ACTION_REQUESTS = [
  'CanManageWorkflows',
  'CanManageTasks',
  'CanManageWorkforce',
  'CanManageProjects',
  'CanManageWorkstreams',
];

export const STATUSES: Intervention['status'][] = ['open', 'reviewing', 'routed', 'resolved', 'rejected'];

export const SOURCE_TYPES: Intervention['sourceType'][] = [
  'workflow',
  'workflow_run',
  'workflow_step',
  'task',
  'template',
  'project',
  'artifact',
  'workforce',
  'daemon',
  'catalog_item',
  'catalog_version',
  'decision',
];

export const OUTCOMES: InterventionRouteRequest['outcome'][] = [
  'task',
  'decision',
  'workflow_draft',
  'workflow_version',
  'workforce_route',
  'workstream_link',
  'log_only',
];

export const STATUS_VARIANT: Record<Intervention['status'], BadgeVariant> = {
  open: 'warning',
  reviewing: 'info',
  routed: 'info',
  resolved: 'success',
  rejected: 'danger',
};

export const SEVERITY_VARIANT: Record<Intervention['severity'], BadgeVariant> = {
  info: 'neutral',
  warning: 'warning',
  error: 'danger',
  critical: 'danger',
};
